import {buzzTypeList} from '@utils'

export default {
    getEnterInfo: state =>{
        const {userInfo} = state;
        const {enterStatus,buzzType,settleInType}  = userInfo || {};
        let purposeModeName = ''
        if(buzzType) {
            const item = buzzTypeList.find(item =>item.type == buzzType)
            if(item) {
                purposeModeName = item.name;
            }
        }     
        return {
            enterStatus,
            buzzType,
            settleInType:settleInType || 0,
            purposeModeName
        }
    }
}
